import { useQuery, useQueryClient } from 'react-query';

import { getRealtorClients } from 'resources/user/workflows';

export default function useRealtorClients(realtorId, {
  excludeDeals = false,
  ...queryOptions
} = {}) {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useQuery(
    ['users.getRealtorClients', realtorId],
    () => getRealtorClients(realtorId, currentUser.company_id, excludeDeals),
    queryOptions,
  );
}
